export default __webpack_public_path__ + "static/media/SWT1670.34I-39066_-23024_0.aa6cc200.jpg";